module.exports = __webpack_public_path__ + "static/andreas_eraker-41f59bbbaea299391f71ac461163f3dc.jpg";